/**
 * MEMORY.md and SOUL.md as the loan officer reads and edits them. Each learned fact in MEMORY.md
 * carries a hidden id (`<!-- mem_… -->`); the server matches unchanged lines by their text, so the
 * markers stay out of sight here.
 */
const ID_MARK = /\s*<!--\s*mem_[\w-]+\s*-->/g;

/** The document without its hidden markers or its own title line. */
export const toEditableDoc = (markdown = "") =>
  markdown
    .replace(ID_MARK, "")
    .replace(/^#\s+MEMORY\.md\s*\n+/, "")
    .trim();

/** Headings, bullets and paragraphs, for a read-only view without a markdown library. */
export const toDocBlocks = (markdown = "") => {
  const blocks = [];
  for (const raw of toEditableDoc(markdown).split("\n")) {
    const line = raw.trim();
    if (!line) {
      continue;
    }
    const heading = /^#{1,6}\s+(.+)$/.exec(line);
    const item = /^[-*+]\s+(.+)$/.exec(line);
    if (heading) {
      blocks.push({ type: "heading", text: heading[1], items: [] });
    } else if (item) {
      const last = blocks[blocks.length - 1];
      if (last && last.type !== "paragraph") {
        last.items.push(item[1]);
      } else {
        blocks.push({ type: "list", items: [item[1]] });
      }
    } else {
      blocks.push({ type: "paragraph", text: line });
    }
  }
  return blocks;
};
